/// <reference path="../../app.definition.ts" />

import moment from "moment";
import { Invitation } from "./invitation";
import { Provider } from "./provider";
import { Serializable } from "./Serializable";
import { Team } from "./team";
import { User } from "./user";
import { NULL_TEXT } from "./constants";

export enum TeamTypeEnum {
    PROJECT = "PROJECT",
    CARE_RECIEPIENT = "INDIVIDUAL",
    STUDENT = "student"
}
export enum FrozenStatusEnum {
    FREEZE = "FROZEN",
    UNFREEZE = "UNFREEZE"
}
export enum TeamAccessLevelEnum {
    NOT_MEMBER = "NOT_MEMBER",
    MEMBER = "MEMBER",
    CAPTAIN = "CAPTAIN"
}
export enum TargetEnum {
    ADMIN_UTILITIES = "ADMIN_UTILITIES",
    DISCUSSION = "DISCUSSION",
    DOCUMENT = "DOCUMENT",
    FORM = "FORM",
    SCHOOL = "SCHOOL",
    SERVICE = "SERVICE",
    TEAM = "TEAM",
    TEAMMEMBER = "TEAMMEMBER",
    SERVICENOTE = "SERVICENOTE",
    DASHBOARD = "DASHBOARD",
    RESOURCE_LIBRARY_DOCUMENT = "RESOURCE_LIBRARY_DOCUMENT",
    RESOURCE_LIBRARY_FOLDER = "RESOURCE_LIBRARY_FOLDER",
    RESOURCE_LIBRARY_CHILDFOLDER = "RESOURCE_LIBRARY_CHILDFOLDER",
    ADMIN_FEATURES = "ADMIN_FEATURES",
    USER = 'USER',
    TEAM_ROLE = "TEAM_ROLE",
}
export enum PermissionsEnum {
    CREATE = 'create',
    CREATE_ON_BEHALF = 'createOnBehalf',
    READ = 'read',
    UPDATE = 'update',
    DELETE = 'delete',
    EXTRA = "extra",
    LIST = 'list',
    SHARE = 'share',
    DELETE_INVITED = 'deleteInvited',
    FREEZE = 'freeze',
    LEAVE = 'leave',
    REMOVE = 'remove',
    REMOVE_ORG = 'removeOrg',
    TRANSFER_OWNERSHIP = 'transferOwnership',
    UPDATE_CO_CAPTAIN = 'updateCoCaptain',
    SELF_ASSIGN = "selfAssign",
    UPDATE_TEAM = "updateTeam",
    VIEW_HISTORY = "viewHistory",
    MANAGE = "manage",
    COPY = "copy",
    DEACTIVATE = "deactivate",
    RENAME = "rename"
}
export const INVITATION_STATUS = {
    ADDED: 0,
    ACTIVE: 1,
    INVITED: 2,
    RESEND_INVITE: 3,
    EXPIRED_INVITE: 4
}
export const MEMBER_STATUS = {
    DELETED: 1,
    ADDED: 2,
    INVITED: 4,
    ACTIVE: 8,
    FORMER: 9
}


export class Subject implements Serializable<Subject> {
    type: string;

    subjectId: number;// 12345,
    loading: any; // for frontend
    firstName: string; //////“James”,
    lastName: string;// “Doe”,
    middleName: string;
    lastNameTemp: string;
    gender: string;/// “male”,
    gradeLevel: number;//“5”,
    school: string;//“Nathan Hale Elementary School”,
    photo: string;
    photoMimeType: string;
    orgBirthDate: any;//“2005-01-01T00:00:00.000Z”, // in UTC
    birthDate: any;//“2005-01-01T00:00:00.000Z”, // in UTC
    providers: Provider[];
    teamMembers: User[] = [];
    resource: any;
    age: any;
    relation: string;
    teamRoleId: any;
    teamRole: any;
    teamOrgId: number;
    prevTeamRoleId: any;
    parent: User;
    ownerId;
    tempPhoto: string;
    isActiveTeamMember: boolean = false; //Defines whether current user is a member of the team or not
    isFrozen: boolean = false;
    isFormerTeamMember: boolean = false;
    frozenDate: any;
    invitation: Invitation;
    careTeamActions: User[];
    bgColor: string;
    exitDate: Date;
    showFormerTeamMembers: boolean = false;
    allowEdit: boolean = false;
    coCaptain: boolean = false;
    teams: Team[] = [];
    teamMemberList: User[];
    // user is team member
    isTeamMember: boolean = false;
    // user is team member but not former
    isActiveMember: boolean = false;
    /* Projects Start*/
    projectId: number;
    projectName: string;
    startDate: any;
    endDate: any;
    projectDescription: string;
    projectType: any;
    subjectTypeId: any;
    projectTypeId: any;
    prevProjectTypeId: any;
    associatedSubjects: Subject[] = [];
    /* Projects Start*/

    birthDateShort: any;
    startDateShort: any;
    endDateShort: any;
    month;
    day;
    year;
    date;
    initialName: string;
    teamType: string;
    teamOrgShortName: string;
    teamOrgName: string;
    teamPartyParentId: number;
    teamPartyId: number;
    studentId: number;
    teamId: number;
    uniqueId: string;
    customAttributeTemplate: any;
    customAttributeEntities;
    customAttributes;
    gradeDisplay;
    clientUsername;
    updateAge = function () {
        var today = new Date();
        var birthDate = new Date(this.birthDate);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        this.age = age;

        //this.ageText = false;
        if (this.age > 1) {
            this.ageText = this.age + ' Years old';
        } else {

            var m = moment().diff(moment(this.birthDate), 'months')
            if (m) {
                if (m < 12) {
                    this.ageText = m + ' Month' + (m == 1 ? '' : 's') + ' old';
                } else {
                    this.ageText = '1 Year old';
                }
            } else {
                var d = moment().diff(moment(this.birthDate), 'days')
                this.ageText = d + ' Day' + (d == 1 ? '' : 's') + ' old';
            }
        }
    };

    getAgeText = () => {
        if (!!this.ageText) {
            // do nothing
        }
        else if (this.age == null) {
            this.ageText = null
        }
        else {
            this.ageText = this._getAgeText();
        }

        return this.ageText;
    }

    _getAgeText = () => {
        if (!this.age) {
            this.updateAge();
        }

        if (this.age > 1) {
            return this.age + ' Years old';
        } else {

            var m = moment().diff(moment(this.birthDate), 'months')
            if (m) {
                if (m < 12) {
                    return m + ' Month' + (m == 1 ? '' : 's') + ' old';
                } else {
                    return '1 Year old';
                }
            } else {
                var d = moment().diff(moment(this.birthDate), 'days')
                return d + ' Day' + (d == 1 ? '' : 's') + ' old';
            }
        }
    }

    getShortDate = (dtms) => {
        if (!!dtms) {
            let dd = new Date(Number(dtms));
            return new Date(dd.getUTCFullYear(), dd.getUTCMonth(), dd.getUTCDate());
        }
    }

    getShortDateTime = (dtms) => {
        if (!!dtms) {
            let dd = new Date(Number(dtms));
            return new Date(dd.getUTCFullYear(), dd.getUTCMonth(), dd.getUTCDate(), dd.getUTCHours(), dd.getUTCMinutes(), dd.getUTCSeconds());
        }
        return null;
    }
    checkBirthDateInfo = (birthDate) => {
        var ignoredDate = -2208988800000;
        // this.birthDate=-2208988800;
        if (!!birthDate) {
            if (birthDate == ignoredDate) {
                this.age = null;
                this.ageText = null
                this.birthDate = undefined
                this.birthDateShort = undefined
                return
            }

            var dd = new Date(birthDate);
            this.birthDate = birthDate;
            this.birthDateShort = new Date(dd.getUTCFullYear(), dd.getUTCMonth(), dd.getUTCDate());
            this.updateAge();
        }
        return

    }



    fullName;
    userPerm: any;
    ageText: any;
    frozenTeamDetails: string;
    public _fullName() {
        if (!this.subjectTypeId || this.subjectTypeId == 'INDIVIDUAL') {
            this.fullName = this.firstName.trim() + ' ' + (this.middleName ? (this.middleName.trim() + ' ') : '') + this.lastName.trim();
        } else if (this.subjectTypeId == 'PROJECT') {
            this.fullName = this.projectName;
        }
    }

    parentFirstName;

    parentLastName;



    // this will be used for casting JSON to object
    deserialize(input) {

        if (input.firstName) {
            this.initialName = input.firstName.charAt(0).toUpperCase();
        }
        if (input.lastName) {
            this.initialName += input.lastName.charAt(0).toUpperCase();
        }
        if (!input.subjectId && !input._id) return;
        if (input._id)
            this.subjectId = input._id;// 12345,
        else
            this.subjectId = input.subjectId;// 12345,
        this.firstName = input.firstName;
        this.middleName = input.middleName;
        this.lastName = input.lastName;
        this.lastNameTemp = input.lastName;
        this.gender = input.gender;
        this.teamType = input.teamType || "individual";
        this.gradeLevel = input.gradeLevel;
        this.school = input.school;
        this.allowEdit = input.allowEdit;
        this.gradeDisplay = input.gradeDisplay;
        this.checkBirthDateInfo(input.birthDate)

        if (!!input.startDate) {
            var dd = new Date(input.startDate);
            this.startDate = input.startDate;
            this.startDateShort = new Date(dd.getUTCFullYear(), dd.getUTCMonth(), dd.getUTCDate());
        }

        if (!!input.endDate) {
            var dd = new Date(input.endDate);
            this.endDate = input.endDate;
            this.endDateShort = new Date(dd.getUTCFullYear(), dd.getUTCMonth(), dd.getUTCDate());
        }
        this.projectName = input.projectName;
        this.projectDescription = input.projectDescription;
        this.clientUsername = input.clientUsername;

        this.parentFirstName = input.parentFirstName;
        this.parentLastName = input.parentLastName;
        this.resource = input.resource;
        if (!!input.parentFirstName && !!input.parentLastName && !!input.parentId) {
            this.parent = new User();
            this.parent.firstName = input.parentFirstName;
            this.parent.lastName = input.parentLastName;
            this.parent.userId = input.parentId;
        }
        input.teamRoleId && (this.teamRoleId = input.teamRoleId);
        input.teamRoleId && (this.prevTeamRoleId = input.teamRoleId);
        input.teamRole && (this.teamRole = input.teamRole);
        input.subjectTypeId && (this.subjectTypeId = input.subjectTypeId);
        input.projectTypeId && (this.projectTypeId = input.projectTypeId);
        input.projectType && (this.projectType = input.projectType);
        input.prevProjectTypeId && (this.prevProjectTypeId = input.prevProjectTypeId);
        input.projectId && (this.projectId = input.projectId);
        input.uniqueId && (this.uniqueId = input.uniqueId);   //uniqueId
        input.prevTeamRoleId && (this.prevTeamRoleId = input.prevTeamRoleId);
        input.ownerId && (this.ownerId = input.ownerId);
        this.photoMimeType = "image/png";
        input.photo && (this.photo = input.photo);
        input.tempPhoto && (this.tempPhoto = input.tempPhoto);
        !!this.tempPhoto || (this.tempPhoto = this.photo);
        this.relation = input.relation;
        if (!!input.providers) {
            this.providers = [];
            for (var i = 0; i < input.providers.length; i++) {
                var provider = input.providers[i];

                var tempProvider = new Provider().deserialize(provider);

                this.providers[this.providers.length] = tempProvider;

            }

        }

        if (!!input.teamMembers && input.teamMembers.length > 0) {
            this.teamMembers = [];
            for (var i = 0; i < input.teamMembers.length; i++) {
                var TM = input.teamMembers[i];

                var tempTM = new User().deserialize(TM);

                this.teamMembers[this.teamMembers.length] = tempTM;

            }

        }

        for (var i = 0; !!input.associatedSubjects && i < input.associatedSubjects.length; i++) {
            this.associatedSubjects.push(new Subject().deserialize(input.associatedSubjects[i]));
        }

        for (var i = 0; !!input.teams && i < input.teams.length; i++) {
            input.teams[i].subjectId = input.subjectId;
            this.teams.push(new Team().deserialize(input.teams[i]));
        }

        this.isActiveTeamMember = input.isActiveTeamMember;
        input.isFormerTeamMember && (this.isFormerTeamMember = input.isFormerTeamMember);
        input.coCaptain && (this.coCaptain = input.coCaptain);
        input.bgColor && (this.bgColor = input.bgColor);
        input.teamOrgId && (this.teamOrgId = input.teamOrgId);
        input.customAttributeTemplate && (this.customAttributeTemplate = input.customAttributeTemplate);
        input.customAttributeEntities && (this.customAttributeEntities = input.customAttributeEntities);
        input.teamId && (this.teamId = input.teamId);
        input.teamOrgShortName && (this.teamOrgShortName = input.teamOrgShortName);
        input.teamOrgName && (this.teamOrgName = input.teamOrgName);
        input.teamPartyParentId && (this.teamPartyParentId = input.teamPartyParentId);
        input.teamPartyId && (this.teamPartyId = input.teamPartyId);

        this.isTeamMember = input.isTeamMember; // user is team member | this flag will return true for former and former reinvite

        this.isActiveMember = input.isTeamMember && !input.isFormerTeamMember;// user is activeteammember ismembernotformemr
        if (input.customAttributeEntities) {
            this.customAttributes = Object.keys(input.customAttributeEntities).reduce((obj, key) => {
                obj[key] = input.customAttributeEntities[key].value;
                !!input.customAttributeEntities[key].displayValue && (obj[key + 'Display'] = input.customAttributeEntities[key].displayValue);
                return obj;
            }, {});
        }
        if (input.studentId) {
            this.studentId = input.studentId;
        } else if (this.customAttributes && this.customAttributes.studentId) {
            this.studentId = this.customAttributes.studentId;
        }

        this._fullName();
        this.getAgeText();

        this.isFrozen = input.isFrozen;
        if (input.frozenDate) {
            this.frozenDate = new Date(input.frozenDate);
            this.frozenTeamDetails = this.frozenDate.toLocaleString("en-us", { month: "long" })
                + " " + this.frozenDate.getUTCDate() + ", " + this.frozenDate.getUTCFullYear();
        }

        (input.invitationRecord) && (this.invitation = new Invitation().deserialize(input.invitationRecord));
        if (!this.invitation) {
            (input.invitation) && (this.invitation = new Invitation().deserialize(input.invitation));
        }


        !!input.exitDate && (this.exitDate = input.exitDate);

        return this;
    }

    update(input?: any) {
        if (!!input) {
            if (input.firstName) {
                this.initialName = input.firstName.charAt(0).toUpperCase();
            }
            if (input.lastName) {
                this.initialName += input.lastName.charAt(0).toUpperCase();
            }
            !!input.firstName && (this.firstName = input.firstName);
            this.middleName = input.middleName;
            !!input.lastName && (this.lastName = input.lastName);
            !!input.gender && (this.gender = input.gender);
            !!input.gradeLevel && (this.gradeLevel = input.gradeLevel);
            !!input.school && (this.school = input.school);
            !!input.ownerId && (this.ownerId = input.ownerId);
            this.checkBirthDateInfo(input.birthDate)

            if (!!input.startDate) {
                var dd = new Date(input.startDate);
                this.startDate = input.startDate;
                this.startDateShort = new Date(dd.getUTCFullYear(), dd.getUTCMonth(), dd.getUTCDate());
            }

            if (!!input.endDate) {
                var dd = new Date(input.endDate);
                this.endDate = input.endDate;
                this.endDateShort = new Date(dd.getUTCFullYear(), dd.getUTCMonth(), dd.getUTCDate());
            }
            !!input.clientUsername && (this.clientUsername = input.clientUsername);
            !!input.projectName && (this.projectName = input.projectName);
            !!input.projectDescription && (this.projectDescription = input.projectDescription);
            !!input.projectTypeId && (this.projectTypeId = input.projectTypeId);

            !!input.photo && (this.photo = input.photo);
            !!input.photo && (this.tempPhoto = input.photo);
            (input.isFrozen != null) && (this.isFrozen = input.isFrozen);
            (input.isFormerTeamMember != null) && (this.isFormerTeamMember = input.isFormerTeamMember);
            (input.coCaptain != null) && (this.coCaptain = input.coCaptain);
            input.customAttributeTemplate && (this.customAttributeTemplate = input.customAttributeTemplate);
            (input.isTeamMember != null) && (this.isTeamMember = input.isTeamMember);
            this.isActiveMember = this.isTeamMember && !this.isFormerTeamMember;
            if (!!input.associatedSubjects) {
                this.associatedSubjects = [];
                for (var i = 0; i < input.associatedSubjects.length; i++) {
                    this.associatedSubjects.push(new Subject().deserialize(input.associatedSubjects[i]));
                }
            }
            if (!!input.teams) {
                this.teams.splice(0, this.teams.length, ...input.teams)
            }
            if (input.studentId) {
                this.studentId = input.studentId;
            } else if (this.customAttributes && this.customAttributes.studentId) {
                this.studentId = this.customAttributes.studentId;
            }
        }
        this._fullName();
        this.getAgeText();
    }

    constructor() {

        // The below data is test data

    }

    getObject(id) {
        this.subjectId = id;

        return this;
    }
}

export class RiskTier {
    id: number;
    name: string;
    constructor(id, name) {
        this.id = id;
        this.name = name;
    }
}

export class School {
    id: number;
    name: string;

    constructor(id, name) {
        this.id = id;
        this.name = name;
    }
}

export class StudentGrade {
    id: number;
    grade: string;
    constructor(id, grade) {
        this.id = id;
        this.grade = grade;
    }
}

export class StudentPlacement {
    status;
    settings;
    schools;

    constructor(input) {
        if (!!input) {
            this.status = [];
            this.settings = [];
            this.schools = [];
            if (input.placementSettings.length > 0) {
                this.settings.push(NULL_TEXT);
            }
            if (input.placementSchools.length > 0) {
                this.schools.push(new School(-1, NULL_TEXT));
            }
            input.placementStatus.forEach(s => {
                this.status.push(s.status);
            });
            input.placementSettings.forEach(s => {
                this.settings.push(s.setting)
            });
            input.placementSchools.forEach(s => {
                this.schools.push(new School(s.partyId, s.name));
            });
        }
    }
}
export class DistrictInfo {
    id: number;
    name: string;
    riskTierSys: RiskTier;
    riskTiers: Array<RiskTier>;
    schools: Array<School>;

    constructor(input) {
        !!input.partyId && (this.id = input.partyId);
        !!input.name && (this.name = input.name);
        this.riskTierSys = new RiskTier(input.riskTierSystemId, input.riskTierSystemName);
        if (!!input.riskTierSystem && Array.isArray(input.riskTierSystem.tiers)) {
            this.riskTiers = [];
            if (input.riskTierSystem.tiers.length > 0) {
                this.riskTiers.push(new RiskTier(-1, NULL_TEXT));
            }
            input.riskTierSystem.tiers.forEach(rs => {
                this.riskTiers.push(new RiskTier(rs.id, rs.tierDisplay));
            });
        }
        if (!!input.schools) {
            this.schools = [];
            if (input.schools.length > 0) {
                this.schools.push(new School(-1, NULL_TEXT));
            }
            input.schools.forEach(s => {
                this.schools.push(new School(s.partyId, s.name));
            });
        }
    }
}

export class SubjectPayload {
    subjectId: number;
    teamId: number;
    firstName: string;
    lastName: string;
    middleName: string;
    gender: string;
    photo: string;
    photoMimeType: string;
    birthDate: any;
    projectId: number;
    projectName: string;
    startDate: any;
    endDate: any;
    projectDescription: string;
    projectTypeId: any;
    customAttributesMap: any;

    constructor(input) {
        this.firstName = input.firstName;
        this.middleName = input.middleName;
        this.lastName = input.lastName;
        this.gender = input.gender;
        this.birthDate = input.birthDate;
        this.startDate = input.startDate;
        this.endDate = input.endDate;
        this.projectName = input.projectName;
        this.projectDescription = input.projectDescription;
        this.projectId = input.projectId;
        this.subjectId = input.subjectId;
        this.photo = input.photo;
        this.photoMimeType = input.photoMimeType;
        this.teamId = input.teamId;
        this.projectTypeId = input.projectTypeId;
    }
}

